
const authLayoutStyles = {
  root: {
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    minHeight: "100vh",
  },
  rootBox: {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    flex: "1 1 auto",
    flexDirection: "column",
    // backgroundImage: `url(${AuthBackground})`,
    backgroundSize: "cover",
  },
  container: {
    py: {
      xs: "12px",
      md: "10px",
    },
    overflow: "visible", // Allow content to be visible when zoomed
    width: "100%",
    maxWidth: "100%",
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    mb: 4,
  },
};
export default authLayoutStyles;
